export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  ASSIGNMENT_V2: 'assignment_v2',
  ADVANCED_ASSIGNMENT: 'advanced_assignment',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  WHATSAPP_CAMPAIGNS: 'whatsapp_campaign',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  PIPELINE_BOARD: 'pipeline_board',
  FOLLOW_UPS: 'follow_ups',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  INBOX_VIEW: 'inbox_view',
  SLA: 'sla',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_WEBSITE: 'channel_website',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
  IP_LOOKUP: 'ip_lookup',
  LINEAR: 'linear_integration',
  CAPTAIN: 'captain_integration',
  CAPTAIN_TASKS: 'captain_tasks',
  CUSTOM_ROLES: 'custom_roles',
  CHATWOOT_V4: 'chatwoot_v4',
  CHANNEL_INSTAGRAM: 'channel_instagram',
  CONTACT_CHATWOOT_SUPPORT_TEAM: 'contact_chatwoot_support_team',
  CAPTAIN_CUSTOM_TOOLS: 'custom_tools',
  CAPTAIN_V2: 'captain_integration_v2',
  SAML: 'saml',
  QUOTED_EMAIL_REPLY: 'quoted_email_reply',
  ADVUP_LABS: 'advup_labs',
  MENU_APPS: 'menu_apps',
  LEAD_SCORE: 'lead_score',
  COMPANIES: 'companies',
  ADVANCED_SEARCH: 'advanced_search',
  CONVERSATION_REQUIRED_ATTRIBUTES: 'conversation_required_attributes',
  APPOINTMENTS_MODULE: 'appointments_module',
  APPOINTMENTS_CAPTAIN_BOOKING: 'appointments_captain_booking',
  APPOINTMENTS_GOOGLE_SYNC: 'appointments_google_sync',
  APPOINTMENTS_PUBLIC_WIDGET: 'appointments_public_widget',
  // Advup: Broadcasts (Disparador em Massa)
  BROADCASTS: 'disparador',
  // Advup: Chat Interno
  INTERNAL_CHAT: 'chat_interno',
  // Advup: Pipeline Sequences (cadências de atividades por card)
  PIPELINE_SEQUENCES: 'pipeline_sequences',
  // Advup: Análise Comercial IA
  ANALISE_COMERCIAL: 'analise_comercial',
  // Conversation unread counts per inbox/label/team
  CONVERSATION_UNREAD_COUNTS: 'conversation_unread_counts',
  // Advup: Módulo Jurídico (processos, tarefas, movimentações)
  LEGAL_MODULE: 'legal_module',
  // Advup: Contratos (gestão de contratos/honorários)
  CONTRACTS: 'contracts',
  // Advup: Módulo Financeiro (contas a pagar/receber, faturamento)
  FINANCIAL_MODULE: 'financial_module',
  // Advup: Correio — a caixa de e-mail dentro do advup (docs/email/TELA.md)
  CORREIO: 'correio',
  // Telefonia nativa (Asterisk) contratada — liga o telefone no navegador.
  TELEPHONY: 'telephony',
  // Advup: Módulo Jurídico — Clientes (Sub-fase 3.1 do roadmap de paridade Legal One)
  LEGAL_CLIENTS: 'legal_clients',
  // Advup: GED central (Sub-fase 4.2 do roadmap de paridade Legal One)
  LEGAL_GED_CENTRAL: 'legal_ged_central',
  // Advup: Time Sheet (Processo + Agenda) — teste de integração final 2026-07-17
  LEGAL_TIME_SHEET: 'legal_time_sheet',
  // Advup: Casos — agrupador de Processos relacionados
  LEGAL_CASES: 'legal_cases',
  // Advup: Publicações do diário oficial (P1 da paridade Legal One)
  LEGAL_PUBLICATIONS: 'legal_publications',
};

export const PREMIUM_FEATURES = [
  FEATURE_FLAGS.SLA,
  FEATURE_FLAGS.CAPTAIN,
  FEATURE_FLAGS.CAPTAIN_CUSTOM_TOOLS,
  FEATURE_FLAGS.CUSTOM_ROLES,
  FEATURE_FLAGS.AUDIT_LOGS,
  FEATURE_FLAGS.HELP_CENTER,
  FEATURE_FLAGS.SAML,
  FEATURE_FLAGS.LEAD_SCORE,
  FEATURE_FLAGS.CONVERSATION_REQUIRED_ATTRIBUTES,
  FEATURE_FLAGS.ADVANCED_ASSIGNMENT,
];
